import { render, staticRenderFns } from "./CalendarContactPopup.vue?vue&type=template&id=c019725a&"
import script from "./CalendarContactPopup.vue?vue&type=script&lang=js&"
export * from "./CalendarContactPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c019725a')) {
      api.createRecord('c019725a', component.options)
    } else {
      api.reload('c019725a', component.options)
    }
    module.hot.accept("./CalendarContactPopup.vue?vue&type=template&id=c019725a&", function () {
      api.rerender('c019725a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/calendar/calendar-event-handler/CalendarContactPopup.vue"
export default component.exports